import { clsx as t } from "clsx";
import { jsx as d } from "react/jsx-runtime";
import { Progress as _ } from "@base-ui/react/progress";
var m = "_banner_i03ag_1", v = "_primaryBlue_i03ag_17", y = "_primaryDanger_i03ag_23", b = "_secondaryBlue_i03ag_29", w = "_secondaryDanger_i03ag_35", a = {
  banner: m,
  primaryBlue: v,
  primaryDanger: y,
  secondaryBlue: b,
  secondaryDanger: w
}, B = {
  primary: {
    blue: a.primaryBlue,
    danger: a.primaryDanger
  },
  secondary: {
    blue: a.secondaryBlue,
    danger: a.secondaryDanger
  }
}, E = ({ color: o = "blue", variant: s = "primary", className: e, children: i }) => /* @__PURE__ */ d("div", {
  className: t(a.banner, B[s][o], e),
  children: i
}), k = "_bar_1wpka_1", N = "_track_1wpka_14", f = "_indicator_1wpka_20", A = "_countdown_1wpka_34", D = "_progressBarCountdown_1wpka_1", n = {
  bar: k,
  track: N,
  indicator: f,
  countdown: A,
  progressBarCountdown: D
}, P = ({ value: o, className: s, barColor: e, backgroundColor: i = "none", withBorderRadius: c = !1, ariaLabel: p, countdownDurationInMs: l, isCountdownPaused: u = !1, onCountdownComplete: g }) => {
  const r = l !== void 0;
  return /* @__PURE__ */ d(_.Root, {
    className: t(n.bar, s),
    "data-with-border-radius": c || void 0,
    "aria-label": p,
    value: o,
    style: {
      "--progress-bar-background-color": i,
      ...e ? { "--progress-bar-color": e } : {},
      ...r ? { "--progress-bar-countdown-duration": `${l}ms` } : {}
    },
    children: /* @__PURE__ */ d(_.Track, {
      className: n.track,
      children: /* @__PURE__ */ d(_.Indicator, {
        className: t(n.indicator, r && n.countdown),
        "data-with-border-radius": c || void 0,
        "data-nonzero": o > 0 && !r || void 0,
        "data-paused": r && u || void 0,
        onAnimationEnd: r ? g : void 0
      })
    })
  });
};
export {
  E as n,
  P as t
};
